import { useEffect, useState } from "react";
import NotATruckModal from "./NotATruckModal";

const LabourToggle = ({ setIsNotATruckModalOpen, handleUpdateBookingObject, tripStatus  , handleEstimatePrice}) => {

  // Determine initial `isTruckRequired` from localStorage (VBO) when available.
  // Determine initial `isTruckRequired` from localStorage (VBO) when available.
  // Default to boolean `true` when no value exists in localStorage.
  // If localStorage contains an empty string for isTruckRequired, treat it as `true`.
  const getInitialTruckRequired = () => {
    try {
      const oldBooking = JSON.parse(localStorage.getItem('VBO'));
      if (oldBooking && Object.prototype.hasOwnProperty.call(oldBooking, 'isTruckRequired')) {
        const stored = oldBooking.isTruckRequired;
        if (stored === "") return true;
        if (typeof stored === 'boolean') return stored;
        if (typeof stored === 'string') return stored === 'true';
        return Boolean(stored);
      }
      // no stored value -> default true
      return true;
    } catch (e) {
      return true;
    }
  };

  const initialTruckRequired = getInitialTruckRequired();

  // Invert the UI checked state relative to `isTruckRequired` so that
  // when the toggle is ON (checked === true) it means "labour-only" (no truck).
  // Default booking value (`isTruckRequired`) remains unchanged; checked is the inverse.
  const [checked, setChecked] = useState(!initialTruckRequired);



  useEffect(() => {
    if (!checked) return;
    // When switching to labour-only, clear out any dropoff location previously set.
    handleUpdateBookingObject("dropoffLocation", "", "labourOnly.clearDropoff");
    handleUpdateBookingObject("dropoffLatitude", "", "labourOnly.clearDropoffLat");
    handleUpdateBookingObject("dropoffLongitude", "", "labourOnly.clearDropoffLng");
  }, [checked]);


  return (
    <div className={`w-full bg-[#C8C6DF4D] h-[32.86px] rounded-[8px] flex items-center gap-x-3 font-instrument p-[7px] ${tripStatus === "vehicle" ? "mt-[0px] gap-2" : "mt-[10.2px]"}`}>
      {/* Toggle Switch */}
      <div
        className="w-[36.19px] h-[20.75px] rounded-full flex items-center px-[1px] cursor-pointer transition-all duration-200"
        style={{
          backgroundColor: checked ? "#34318C" : "#CDCCD7",
          justifyContent: checked ? "flex-end" : "flex-start",
        }}
        onClick={() => {
          const newVal = !checked;
          setChecked(newVal);
       
          // Map checked -> isTruckRequired inversely: when checked is true (toggle ON)
          // the booking should be labour-only (isTruckRequired = false)
          const truckRequired = !newVal;
          // Always persist the selection to localStorage so a refresh will keep it.
          try {
            const oldBooking = JSON.parse(localStorage.getItem('VBO')) || {};
            const merged = { ...oldBooking, isTruckRequired: truckRequired, updatedAt: new Date().toISOString() };
            localStorage.setItem('VBO', JSON.stringify(merged));
            handleEstimatePrice(null, null, true);
          } catch (e) {
            console.error(e);
          }

          // Also call external updater if provided (keep existing behaviour)
          if (typeof handleUpdateBookingObject === 'function') {
            handleUpdateBookingObject('isTruckRequired', truckRequired, 'labour_toggle');
          }
        }}
      >
        <div className="w-[18px] h-[18px] rounded-full bg-white transition-all duration-200"></div>
      </div>

      {/* Text */}
      <p className="text-[#373559] text-[12px] font-normal max-420:text-[10.5px]">
        Don’t need a truck? Choose labour-only
      </p>

      {/* Info icon */}
      <button className="ml-auto" onClick={() => setIsNotATruckModalOpen(true)}>

        <img
          src="/images/NewUiIcons/InfoIcon.svg"
          alt="info icon"
          width="17"
          height="17"
        />
      </button>

    </div>
  );
};

export default LabourToggle;
